export default "__VITE_ASSET__fp_EeNsU__"